import { onBeforeUnmount, onMounted } from 'vue'
import Mousetrap from 'mousetrap'

import { useReportGraphsDrawer } from '@app/application/report/store/use-report-graphs-drawer'
import {
  getLeftDrawerHotkey,
  isInputFocused,
} from '@app/application/behaviors/drawers/hotkeys'
import { isUsingNewLayout } from '@app/adapters/silverfin'

// Binds ⌥/Alt + the left-drawer key to toggle the chart pane for the calling
// component's lifetime, mirroring the existing drawer hotkeys. Alt is the one
// modifier free of browser chrome collisions for these punctuation keys
// (mod+, is Preferences on macOS, mod+[ is Back) and Mousetrap matches alt
// combos by key code, so the locale variants also work on AZERTY layouts.
// The pane only exists in the new layout; elsewhere this is a no-op.
export function useReportPaneToggleHotkey(): void {
  if (!isUsingNewLayout()) return

  const store = useReportGraphsDrawer()
  const hotkey = `alt+${getLeftDrawerHotkey()}`

  // Stays bound while the pane is collapsed so the shortcut can re-open it —
  // the calling component remains mounted; the collapse is a CSS transform.
  onMounted(() => {
    Mousetrap.bind(hotkey, () => {
      if (isInputFocused()) return true
      store.toggleDrawer()
      return false
    })
  })

  onBeforeUnmount(() => Mousetrap.unbind(hotkey))
}
